/**
 * Client mirror of the server permissions catalogue (`routes` keys and
 * `resources` × `actions`). The server resolves the final matrix on login
 * (`overWritePermissions`); the client reads the snapshot via
 * `permissionUtility` — never re-derives booleans here.
 *
 * New screen → add a `ROUTE_PERMISSION` key, tag the route meta, wire the
 * sidebar entry. New button guard → extend `RESOURCE` / `ACTION` when a UI
 * surface actually checks it.
 *
 * Ticket resources use create / edit / delete only — there is no separate
 * `read`; route access (`ticketManagement`, etc.) gates viewing.
 */

/* prettier-ignore */
export const ROUTE_PERMISSION = Object.freeze({
  /* Account-scope ticket pages (v2). */
  TICKET_MANAGEMENT: 'ticketManagement',
  TICKET_TRACKING: 'ticketTracking',
  TICKET_SETTINGS: 'ticketSettings',

  /* Group-scope ticket pages (v2). */
  G_TICKET_MANAGEMENT: 'g-ticketManagement',
  G_TICKET_TRACKING: 'g-ticketTracking',
  G_TICKET_SETTINGS: 'g-ticketSettings',

  PROFILE: 'profile',
  SUBSCRIPTIONS: 'subscriptions',
  COLLABORATORS: 'collaborators',
  SETTINGS: 'settings',
  GROUP_SETTINGS: 'g-settings',
  DOCUMENTATION: 'documentation',

  /* Admin-only. */
  ADMIN_DASHBOARD: 'adminDashboard',
})

export const RESOURCE = Object.freeze({
  TICKET: 'ticket',
  TICKET_SETTING: 'ticketSetting',
  TICKET_GROUP: 'ticketGroup',
  INVOICE: 'invoice',
  TENANT: 'tenant',
  APARTMENT: 'apartment',
})

export const ACTION = Object.freeze({
  CREATE: 'create',
  READ: 'read',
  EDIT: 'edit',
  DELETE: 'delete',
})
